import { useLocation, useParams } from 'react-router-dom';
// material
import { Container } from '@material-ui/core';
import { useEffect } from 'react';
import InvoiceNewForm from '../../../components/_dashboard/invoice/InvoiceNewForm';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import { getInvoice } from '../../../redux/slices/invoice';

// ----------------------------------------------------------------------

export default function InvoiceCreate() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { serie, number } = useParams();
  const { invoice } = useSelector((state) => state.invoiceP);
  const isEdit = pathname.includes('edit');
  const { selectedCompanyId } = useSelector((state) => state.userP);

  useEffect(() => {
    if (isEdit) {
      dispatch(getInvoice(selectedCompanyId, serie, number));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getInvoice, dispatch]);

  if (isEdit && !invoice) {
    return null;
  }

  return (
    <Page title="Factura: Crear nueva factura">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading={!isEdit ? `Crear nueva factura serie: ${serie}` : 'Editar factura'}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: `Listado Facturas ${serie}`, href: `${PATH_DASHBOARD.invoice.series}${serie}` },
            { name: !isEdit ? 'Nueva factura' : `Editar factura ${invoice?.invoiceNumber}` }
          ]}
          key="invoice"
        />

        <InvoiceNewForm isEdit={isEdit} serie={serie} currentInvoice={invoice} />
      </Container>
    </Page>
  );
}
